import { fetcherCMS } from '@/modules/api';
import { getCMSLocale } from '@/modules/cms';
import {
  type CMSApiBase,
  type CMSImageBase,
  type CMSOrder,
  createCmsUrl,
} from './base';
import type { BonusMinDepV2 } from './bonuses';

export enum BonusShopProductType {
  FREE_SPINS = 'fs',
  CASH = 'cash',
  CASH_BONUS = 'bonus_cash',
  LOOTBOX = 'lootbox',
  PREMIUM = 'premium',
}

export enum BonusShopLabel {
  NEW = 'new',
  VIP = 'vip',
  SPECIAL = 'special',
}

interface BonusShopProductBase extends CMSOrder {
  id: number;
  group: string;
  img: CMSImageBase;
  label: BonusShopLabel | null;
  cpPrice: number;
  productTerms: string;
  durationTo: string | null;
}

export interface BonusShopCash extends BonusShopProductBase {
  amount: BonusMinDepV2[];
}

export interface BonusShopCashBonus extends BonusShopProductBase {
  amount: BonusMinDepV2[];
  wager: string;
}

export interface BonusShopLootbox extends BonusShopProductBase {
  title: string;
  winUpTo: BonusMinDepV2[];
}

export interface BonusShopPremium extends BonusShopProductBase {
  title: string;
  amount: BonusMinDepV2[];
}

export interface BonusShopFsItem {
  id: number;
  group: string;
  game: string | null;
  cpPrice: number;
  fsCount: number;
  spinValue: BonusMinDepV2[];
  wager: string | null;
  maxWin: string | null;
  productTerms: string;
}

export interface BonusShopFs extends CMSApiBase, CMSOrder {
  img: CMSImageBase;
  title: string;
  durationTo: string | null;
  label: BonusShopLabel | null;
  fsItems: BonusShopFsItem[];
}

export interface BonusShopApi {
  cashBonuses: BonusShopCashBonus[];
  cash: BonusShopCash[];
  lootboxes: BonusShopLootbox[];
  premium: BonusShopPremium[];
  generalTerms: string;
}

export const getBonusShopCMSUrl = (lang: string) =>
  createCmsUrl({
    path: 'bonus-shop',
    queryData: { populate: 'deep', ...getCMSLocale(lang) },
  });

export const getBonusShopFsCMSUrl = (lang: string) =>
  createCmsUrl({
    path: 'bonus-shop-fs-s',
    queryData: { populate: 'deep', ...getCMSLocale(lang) },
  });

export const fetchBonusShopCMS = async (lang: string) => {
  const [shop, freeSpins] = await Promise.all([
    fetcherCMS<BonusShopApi>(getBonusShopCMSUrl(lang)),
    fetcherCMS<BonusShopFs[]>(getBonusShopFsCMSUrl(lang)),
  ]);

  return { shop, freeSpins: freeSpins || [] };
};
